<div class="code-header">
  <span class="language-name">{{ lang() }}</span>
  <button
    [pTooltip]="'Click to copy' | toggleTooltipText: 'Copied!' : 1000 : tooltip : toggleCopyTooltip() | async"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
    class="copy-code-btn"
    (click)="copyHighlightCode()"
  >
    Copy code
  </button>
</div>
